import { Anchor, Badge, Card, Group, Stack, Table, Text, TextInput, Title } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { unwrap } from '../api/client';
import { useOrg } from '../api/org';
import { listAgents } from '../api/gen';

export function AgentsPage() {
  const headers = useOrg();
  const [search, setSearch] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: ['agents', search],
    queryFn: () => unwrap(listAgents({ headers, query: { limit: 100, search: search || undefined } })),
  });

  return (
    <Stack>
      <Group justify="space-between">
        <Title order={3}>Agents</Title>
        <TextInput
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value)}
          w={220}
        />
      </Group>

      <Text c="dimmed" size="sm">
        An agent is a folder of files. It arrives here by <code>mindvm dev</code>,
        and what runs is what is in the folder.
      </Text>

      <Card withBorder p={0}>
        <Table striped highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Agent</Table.Th>
              <Table.Th>Model</Table.Th>
              <Table.Th>Risk</Table.Th>
              <Table.Th>Source</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {isLoading && (
              <Table.Tr>
                <Table.Td colSpan={4}>Loading…</Table.Td>
              </Table.Tr>
            )}
            {data?.data.map((a) => {
              const gov = (a.governance ?? {}) as { riskTier?: string };
              return (
                <Table.Tr key={a.id}>
                  <Table.Td>
                    <Anchor component={Link} to={`/agents/${a.id}`}>
                      {a.localId}
                    </Anchor>
                    <Text size="xs" c="dimmed">
                      {a.name}
                    </Text>
                  </Table.Td>
                  <Table.Td>
                    <Text size="sm">{a.model.name || '—'}</Text>
                  </Table.Td>
                  <Table.Td>
                    <Badge variant="light" color={gov.riskTier === 'high' ? 'orange' : 'gray'}>
                      {gov.riskTier ?? 'undeclared'}
                    </Badge>
                  </Table.Td>
                  <Table.Td>
                    <Text size="xs" c="dimmed" ff="monospace">
                      {a.sourceHash.replace('sha256:', '').slice(0, 12)}
                    </Text>
                  </Table.Td>
                </Table.Tr>
              );
            })}
            {data?.data.length === 0 && (
              <Table.Tr>
                <Table.Td colSpan={4}>
                  <Text c="dimmed">
                    No agents. Run <code>mindvm init</code> and <code>mindvm dev</code>.
                  </Text>
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </Card>
    </Stack>
  );
}
